// Prompt AD (2026-09-21) — Site Inspection "INSPECTION DETAILS": Inspection
// Type, Inspector, Findings/Observations, Recommendation. El Status ya se
// ve en el stepper de arriba, no se duplica aquí.
import { useState } from 'react';
import api from '@/lib/api';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';
import { Search, Save as SaveIcon } from 'lucide-react';
import { toast } from 'sonner';

export default function InspectionDetailsCard({ job, onSaved }) {
  const d = job.inspection_details || {};
  const [draft, setDraft] = useState({
    inspection_type: d.inspection_type || '', inspector: d.inspector || '',
    findings: d.findings || '', recommendation: d.recommendation || '',
  });
  const [saving, setSaving] = useState(false);

  const handleSave = async () => {
    setSaving(true);
    try {
      const res = await api.put(`/jobs/${job.id}`, { inspection_details: draft });
      onSaved(res.data);
      toast.success('Inspection Details guardado');
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Error al guardar');
    } finally {
      setSaving(false);
    }
  };

  return (
    <Card className="bg-white border-gray-100 shadow-sm" data-testid="inspection-details-card">
      <CardHeader className="pb-2">
        <CardTitle className="text-sm font-semibold font-['Barlow'] flex items-center gap-2">
          <Search className="w-4 h-4 text-[#3399FF]" /> Inspection Details
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-3">
        <div className="grid grid-cols-2 gap-2.5">
          <div className="space-y-1">
            <Label className="text-[10px] text-gray-500 uppercase">Inspection Type</Label>
            <Input className="h-9 text-xs" value={draft.inspection_type} onChange={e => setDraft({ ...draft, inspection_type: e.target.value })} data-testid="inspection-type-input" />
          </div>
          <div className="space-y-1">
            <Label className="text-[10px] text-gray-500 uppercase">Inspector</Label>
            <Input className="h-9 text-xs" value={draft.inspector} onChange={e => setDraft({ ...draft, inspector: e.target.value })} data-testid="inspection-inspector-input" />
          </div>
        </div>
        <div className="space-y-1">
          <Label className="text-[10px] text-gray-500 uppercase">Findings / Observations</Label>
          <Textarea rows={3} className="text-sm" value={draft.findings} onChange={e => setDraft({ ...draft, findings: e.target.value })} data-testid="inspection-findings-input" />
        </div>
        <div className="space-y-1">
          <Label className="text-[10px] text-gray-500 uppercase">Recommendation</Label>
          <Textarea rows={3} className="text-sm" value={draft.recommendation} onChange={e => setDraft({ ...draft, recommendation: e.target.value })} data-testid="inspection-recommendation-input" />
        </div>
        <div className="flex justify-end">
          <Button size="sm" className="h-8 text-xs bg-[#003366] hover:bg-[#004080] text-white" onClick={handleSave} disabled={saving} data-testid="inspection-details-save-btn">
            <SaveIcon className="w-3.5 h-3.5 mr-1" /> {saving ? 'Guardando…' : 'Save'}
          </Button>
        </div>
      </CardContent>
    </Card>
  );
}
